import { render } from "./wednesday-lunch.vue?vue&type=template&id=96588bd2"
import script from "./wednesday-lunch.vue?vue&type=script&lang=js"
export * from "./wednesday-lunch.vue?vue&type=script&lang=js"
script.render = render

export default script